module.exports = __webpack_public_path__ + "img/private_group.d23770f8.jpg";